import React from 'react';
import { ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ListItemProps } from './listItemProps';
import { ListItemLink, ListLink, ListItemSvg } from './listItemStyles';
import Strings from '../../i18n';

export const ListItem: React.FC<ListItemProps> = ({
  selectedId,
  children,
  name,
  path
}) => {
  const navigate = useNavigate();

  const goToPage = (e: React.MouseEvent) => {
    const match = path.match(/\/locations\/(\d+)\//);
    if (match) {
      const locationId = Number(match[1]);
      e.preventDefault();
      navigate(path, {
        state: {
          type: 'Locations',
          id: locationId
        }
      });
    }
  };

  return name === Strings.locations.notes.locationNotes ? (
    <ListLink as="div" onClick={goToPage}>
      <ListItemLink selected={selectedId === path}>
        <ListItemSvg selected={selectedId === path}>{children}</ListItemSvg>
        <ListItemText primary={name} />
      </ListItemLink>
    </ListLink>
  ) : (
    <ListLink to={path}>
      <ListItemLink selected={selectedId === path}>
        <ListItemSvg selected={selectedId === path}>{children}</ListItemSvg>
        <ListItemText primary={name} />
      </ListItemLink>
    </ListLink>
  );
};
